import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { HealthBanner } from "./components/HealthBanner";
import { Home } from "./routes/Home";
import { Review } from "./routes/Review";

export function App() {
  return (
    <ErrorBoundary>
      <HealthBanner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/review/:orderId" element={<Review />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
